import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { toast } from "react-toastify"
import api, { timeout } from "../../api"
import { setMessage } from "../message/messageSlice"

export const getsStatesdropdown = createAsyncThunk(
  "support/getsStatesdropdown",
  async (_, thunkAPI) => {
    try {
      const response = await api.get(`abide/v1/geo/states/basic`)
      return response?.data
    } catch (error) {
      return thunkAPI.rejectWithValue()
    }
  }
)

//BUSINESS
export const getBusinessLogo = createAsyncThunk(
  "support/getBusinessLogo",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/document/logo/download`, {
        responseType: "blob",
      })
      if (response) {
        const base64String = await convertBlobToBase64(response.data)
        return base64String
      }
    } catch (error) {
      return rejectWithValue()
    }
  }
)
export const uploadBusinessLogo = createAsyncThunk(
  "support/uploadBusinessLogo",
  async ({ inputData }, { dispatch, rejectWithValue }) => {
    try {
      let formdata = new FormData()
      formdata.append("file", inputData.data)
      const response = await api.post(
        `abide/v2/document/logo/upload`,
        formdata,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      if (response) {
        toast.success("Logo uploaded successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
export const getbusinessinfo = createAsyncThunk(
  "support/getbusinessinfo",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v1/business/business`)
      if (response) {
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)

export const editbusinessinfo = createAsyncThunk(
  "support/editbusinessinfo",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(`abide/v1/business/update`, inputData)
      if (response) {
        toast.success("Business information updated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const extendsubscription = createAsyncThunk(
  "support/extendsubscription",
  async ({ inputData }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post(
        `abide/v1/business/extend-subscription`,
        inputData
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
//Clients
export const getallclients = createAsyncThunk(
  "support/getallclients",
  async (_, thunkAPI) => {
    try {
      const response = await api.get(`abide/v1/business/businesses`)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const getclientdetail = createAsyncThunk(
  "support/getclientdetail",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.get(`abide/v1/business/business/${id}`)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const managecharges = createAsyncThunk(
  "support/managecharges",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v1/business/setting/update`,
        inputData
      )
      if (response) {
        toast.success("Changes saved successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const getbusinesses = createAsyncThunk(
  "support/getbusinesses",
  async (_, thunkAPI) => {
    try {
      const response = await api.get(`abide/v1/business/businesses`)
      return response?.data
    } catch (error) {
      return thunkAPI.rejectWithValue()
    }
  }
)
export const getclientsonboardings = createAsyncThunk(
  "support/getclientsonboardings",
  async ({ search }, thunkAPI) => {
    try {
      const response = await api.get(
        `abide/v1/business/onboardings?search=${search}`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const getclientonboardingDetail = createAsyncThunk(
  "support/getclientonboardingDetail",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.get(`abide/v1/business/onboarding/${id}`)
      return response?.data
    } catch (error) {
      return thunkAPI.rejectWithValue()
    }
  }
)
export const initiateonboarding = createAsyncThunk(
  "support/initiateonboarding",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v1/business/onboard/initiate`,
        inputData
      )
      if (response) {
        toast.success("Client onboarding initiated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const respondonboarding = createAsyncThunk(
  "support/respondonboarding",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v1/business/onboard/respond`,
        inputData
      )
      if (response) {
        toast.success("Response sent successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      if (
        (message && message?.status === 428) ||
        message?.message === "please confirm your action"
      ) {
        toast.success(
          "Response initiated successfully, click the button again to confirm your response",
          {
            icon: "🎉",
          }
        )
      } else {
        const newMessage =
          error.response && error.response.data.message
            ? error.response && error.response.data.message
            : error.response && error.response.data.error
            ? error.response && error.response.data.error
            : message
        toast.error(`${newMessage}`, {
          icon: "😱",
        })
      }
      thunkAPI.dispatch(setMessage(message))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const editclientonboarding = createAsyncThunk(
  "support/editclientonboarding",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v1/business/onboarding/edit`,
        inputData
      )
      if (response) {
        toast.success("IRS updated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

export const deleteclientonboarding = createAsyncThunk(
  "support/deleteclientonboarding",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v1/business/onboarding/delete/${id}`,
        {}
      )
      if (response) {
        toast.success("IRS deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

//PARTNERSS
export const getallpartners = createAsyncThunk(
  "support/getallpartners",
  async (_, thunkAPI) => {
    try {
      const response = await api.get(`abide/v1/business/partners`)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

export const getpartnerdetail = createAsyncThunk(
  "support/getpartnerdetail",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.get(`abide/v1/business/partner/${id}`)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const getpartneronboardings = createAsyncThunk(
  "support/getpartneronboardings",
  async ({ search }, thunkAPI) => {
    try {
      const response = await api.get(
        `abide/v1/business/partner/onboardings?search=${search}`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const getpartneronboardingDetail = createAsyncThunk(
  "support/getpartneronboardingDetail",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.get(
        `abide/v1/business/partner/onboarding/${id}`
      )
      return response?.data
    } catch (error) {
      return thunkAPI.rejectWithValue()
    }
  }
)
export const initiatepartneronboarding = createAsyncThunk(
  "support/initiatepartneronboarding",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v1/business/partner/onboarding/initiate`,
        inputData
      )
      if (response) {
        toast.success("Partner onboarded initiated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const respondpartneronboarding = createAsyncThunk(
  "support/respondpartneronboarding",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v1/business/partner/onboarding/authorize`,
        inputData
      )
      if (response) {
        toast.success("Response sent successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

export const editpartner = createAsyncThunk(
  "support/editpartner",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v1/business/partner/onboarding/edit`,
        inputData
      )
      if (response) {
        toast.success("Partner detail updated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

export const deletepartner = createAsyncThunk(
  "support/deletepartner",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v1/business/partner/onboarding/delete/${id}`,
        {}
      )
      if (response) {
        toast.success("Partner deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
// TICKET

export const gettickettypes = createAsyncThunk(
  "support/gettickettypes",
  async (_, thunkAPI) => {
    try {
      const response = await api.get(`portal/ticket/v1/types`)
      return response?.data
    } catch (error) {
      return thunkAPI.rejectWithValue()
    }
  }
)

export const gettickets = createAsyncThunk(
  "support/gettickets",
  async ({ cursor, navigation, pagesize }, thunkAPI) => {
    try {
      const response = await api.get(
        `portal/ticket/v1/tickets?cursor=${cursor}&navigation=${navigation}&page-size=${pagesize}`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const getticketdetail = createAsyncThunk(
  "support/getticketdetail",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.get(`portal/ticket/v1/ticket/${id}`)
      return response?.data
    } catch (error) {
      return thunkAPI.rejectWithValue()
    }
  }
)
export const createticket = createAsyncThunk(
  "support/createticket",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(`portal/ticket/v1/ticket/add`, inputData)
      if (response) {
        toast.success("Ticket created successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

export const editticket = createAsyncThunk(
  "support/editticket",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(`portal/ticket/v1/ticket/edit`, inputData)
      if (response) {
        toast.success("Ticket updated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

export const deleteticket = createAsyncThunk(
  "support/deleteticket",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(
        `portal/ticket/v1/ticket/delete/${id}`,
        {}
      )
      if (response) {
        toast.success("Ticket deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

export const escalateticket = createAsyncThunk(
  "support/escalateticket",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        `portal/ticket/v1/ticket/escalate`,
        inputData
      )
      if (response) {
        toast.success("Ticket escalation sent successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

export const postaction = createAsyncThunk(
  "support/postaction",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        `portal/ticket/v1/ticket/action/add`,
        inputData
      )
      if (response) {
        toast.success("Response sent successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

export const closeaction = createAsyncThunk(
  "support/closeaction",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        `portal/ticket/v1/ticket/close`,
        inputData
      )
      if (response) {
        toast.success("Ticket closed successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

export const deleteaction = createAsyncThunk(
  "support/deleteaction",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(
        `portal/ticket/v1/ticket/action/delete/${id}`,
        inputData
      )
      if (response) {
        toast.success("Response sent successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
//COLLECTIONS
export const getsupportcollections = createAsyncThunk(
  "support/getsupportcollections",
  async (
    { start, end, agency, cashpoint, client, cursor, navigation, pagesize },
    thunkAPI
  ) => {
    try {
      const response = await api.get(
        `abide/payments/v1/transactions?start=${start}&end=${end}&agencyId=${agency}&cashPointId=${cashpoint}&business=${client}&cursor=${cursor}&navigation=${navigation}&page-size=${pagesize}`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const getcollectionsummary = createAsyncThunk(
  "support/getcollectionsummary",
  async ({ start, end }, thunkAPI) => {
    try {
      const response = await api.get(
        `abide/payments/v1/summary?start=${start}&end=${end}`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
const initialState = {
  loading: false,
  detail: null,
  roles: null,
  states: null,
  businesses: null,
  logo: null,
  dataloading: false,
  onboarding: null,
  userbasics: null,
  clients: null,
  onboardingdetail: null,
  business: null,
  businessloading: null,
  partners: null,
  partnerdetail: null,
  partneronboarding: null,
  partneronboardingdetail: null,
  businesses: null,
  tickets: null,
  ticketdetail: null,
  tickettypes: null,
  collections: null,
  collectionsummary: null,
}

const supportSlice = createSlice({
  name: "support",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //BUSINESS INFORMATION
    builder.addCase(getbusinessinfo.pending, (state) => {
      state.loading = true
      state.business = null
    })
    builder.addCase(getbusinessinfo.fulfilled, (state, { payload }) => {
      state.loading = false
      state.business = payload?.data
    })
    builder.addCase(getbusinessinfo.rejected, (state) => {
      state.loading = false
      state.business = null
    })
    builder.addCase(getBusinessLogo.fulfilled, (state, { payload }) => {
      state.logo = payload
    })
    // Clients
    builder.addCase(getclientsonboardings.pending, (state) => {
      state.loading = true
      state.onboarding = null
    })
    builder.addCase(getclientsonboardings.fulfilled, (state, { payload }) => {
      state.loading = false
      state.onboarding = payload?.data
    })
    builder.addCase(getclientsonboardings.rejected, (state) => {
      state.loading = false
      state.onboarding = null
    })
    builder.addCase(getallclients.pending, (state) => {
      state.loading = true
      state.clients = null
    })
    builder.addCase(getallclients.fulfilled, (state, { payload }) => {
      state.loading = false
      state.clients = payload?.data
    })
    builder.addCase(getallclients.rejected, (state) => {
      state.loading = false
      state.clients = null
    })
    builder.addCase(getbusinesses.fulfilled, (state, { payload }) => {
      state.businesses = payload?.data
    })
    builder.addCase(getclientonboardingDetail.pending, (state) => {
      state.onboardingloading = true
      state.onboardingdetail = null
    })
    builder.addCase(
      getclientonboardingDetail.fulfilled,
      (state, { payload }) => {
        state.onboardingloading = false
        state.onboardingdetail = payload?.data
      }
    )
    builder.addCase(getclientonboardingDetail.rejected, (state) => {
      state.onboardingloading = false
      state.onboardingdetail = null
    })
    builder.addCase(getclientdetail.pending, (state) => {
      state.businessloading = true
      state.business = null
    })
    builder.addCase(getclientdetail.fulfilled, (state, { payload }) => {
      state.businessloading = false
      state.business = payload?.data
    })
    builder.addCase(getclientdetail.rejected, (state) => {
      state.businessloading = false
      state.business = null
    })
    // PARTNERS
    builder.addCase(getpartneronboardings.pending, (state) => {
      state.loading = true
      state.partneronboarding = null
    })
    builder.addCase(getpartneronboardings.fulfilled, (state, { payload }) => {
      state.loading = false
      state.partneronboarding = payload?.data
    })
    builder.addCase(getpartneronboardings.rejected, (state) => {
      state.loading = false
      state.partneronboarding = null
    })
    builder.addCase(getallpartners.pending, (state) => {
      state.loading = true
      state.partners = null
    })
    builder.addCase(getallpartners.fulfilled, (state, { payload }) => {
      state.loading = false
      state.partners = payload?.data
    })
    builder.addCase(getallpartners.rejected, (state) => {
      state.loading = false
      state.partners = null
    })

    builder.addCase(getpartneronboardingDetail.pending, (state) => {
      state.onboardingloading = true
      state.partneronboardingdetail = null
    })
    builder.addCase(
      getpartneronboardingDetail.fulfilled,
      (state, { payload }) => {
        state.onboardingloading = false
        state.partneronboardingdetail = payload?.data
      }
    )
    builder.addCase(getpartneronboardingDetail.rejected, (state) => {
      state.onboardingloading = false
      state.partneronboardingdetail = null
    })
    builder.addCase(getpartnerdetail.pending, (state) => {
      state.loading = true
      state.partnerdetail = null
    })
    builder.addCase(getpartnerdetail.fulfilled, (state, { payload }) => {
      state.loading = false
      state.partnerdetail = payload?.data
    })
    builder.addCase(getpartnerdetail.rejected, (state) => {
      state.loading = false
      state.partnerdetail = null
    })

    // TICKETS
    builder.addCase(gettickets.pending, (state) => {
      state.loading = true
      state.tickets = null
    })
    builder.addCase(gettickets.fulfilled, (state, { payload }) => {
      state.loading = false
      state.tickets = payload?.data
    })
    builder.addCase(gettickets.rejected, (state) => {
      state.loading = false
      state.tickets = null
    })
    builder.addCase(gettickettypes.fulfilled, (state, { payload }) => {
      state.tickettypes = payload?.data
    })
    builder.addCase(getticketdetail.pending, (state) => {
      state.ticketloading = true
      state.ticketdetail = null
    })
    builder.addCase(getticketdetail.fulfilled, (state, { payload }) => {
      state.ticketloading = false
      state.ticketdetail = payload?.data
    })
    builder.addCase(getticketdetail.rejected, (state) => {
      state.ticketloading = false
      state.ticketdetail = null
    })
    // COLLECTIONS
    builder.addCase(getsupportcollections.pending, (state) => {
      state.loading = true
      state.collections = null
    })
    builder.addCase(getsupportcollections.fulfilled, (state, { payload }) => {
      state.loading = false
      state.collections = payload?.data
    })
    builder.addCase(getsupportcollections.rejected, (state) => {
      state.loading = false
      state.collections = null
    })
    builder.addCase(getcollectionsummary.pending, (state) => {
      state.loading = true
      state.collectionsummary = null
    })
    builder.addCase(getcollectionsummary.fulfilled, (state, { payload }) => {
      state.loading = false
      state.collectionsummary = payload?.data
    })
    builder.addCase(getcollectionsummary.rejected, (state) => {
      state.loading = false
      state.collectionsummary = null
    })
    builder.addCase(getsStatesdropdown.fulfilled, (state, { payload }) => {
      state.states = payload?.data
    })
  },
})

export default supportSlice.reducer
